import React from "react";
import {Image, ScrollView} from "react-native";
import {
  TournamentPlayerDetails, TournamentPrizeDistributionItem, TournamentPrizeDistributionItem_AwardKind, TournamentState
} from "../../generated/smg_service_pb";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";
import MainStyle from "../../MainStyle";
import {formatCurrency, formatPayout} from "../utils";
import {isFullSwing} from "../constants";
import circle from "../assets/img/icons/circle_dollar.svg";
import ticket from "../assets/img/icons/ticket.svg";
import fs_kit from "../assets/img/icons/FS Kit.svg";

const AwardKind = TournamentPrizeDistributionItem_AwardKind;

type Props = {
  mx?: string | number, maxH?: number | string, prizePoolList?: number[], w?: string | number, b_b_r?: number,
  state?: number, playerDetailsList: TournamentPlayerDetails[], mb?: string | number,
  guaranteedPricePool: number, prizeDistribution?: TournamentPrizeDistributionItem[], entryfee?: number
};

const PrizePool = (props: Props) => {
  const {
    mx, maxH, prizePoolList, w, b_b_r, state, playerDetailsList, mb, guaranteedPricePool, prizeDistribution, entryfee
  } = props;

  const comparePlayerDetails = (a: TournamentPlayerDetails, b: TournamentPlayerDetails) => {
    return b.prize - a.prize;
  };

  const compareNumbers = (a: number, b: number) => {
    return b - a;
  };

  const renderPayout = (el: TournamentPrizeDistributionItem) => {
    if (el.kind === AwardKind.TICKET) {
      return `${el.additionalCashPrize ? formatCurrency(el.additionalCashPrize / 100) + ' + ' : ''}Ticket`;

    } else if (el.kind === AwardKind.STATIC) {
      return formatCurrency(el.staticAwardPrize / 100);

    } else if (el.kind === AwardKind.PHYSICAL_PRIZE) {
      return `${el.additionalCashPrize ? formatCurrency(el.additionalCashPrize / 100) + ' + ' : ''}FS Kit`;

    } else {
      return formatCurrency(el.calculatedAwardPrize / 100);
    }
  };

  return (
    <Div rounded={isFullSwing ? 2 : 20} borderWidth={1} borderColor="#424242" pb={isFullSwing ? 9 : 0}
         bg={isFullSwing ? '#252526' : colors.settings_bg} mx={mx} maxH={maxH} w={w}
         roundedBottomLeft={b_b_r} roundedBottomRight={b_b_r} mb={mb} style={MainStyle.min_h_90}>
      {(isFullSwing && (!!guaranteedPricePool || !!entryfee)) && (
        <Div row h={40} alignItems="center" roundedTop={2} bg="#424242" justifyContent="space-around">
          {!!entryfee && (
            <Div row alignItems="center">
              <P fs={10} w={35}>ENTRY FEE</P>
              <P fs={23}>{formatCurrency(entryfee / 100)}</P>
            </Div>
          )}
          {!!guaranteedPricePool && (
            <Div row alignItems="center">
              <P fs={10} w={65}>GUARANTEED PRIZE POOL</P>
              <P fs={23} fontFamily="DavisSans-Medium" color="#27E9A6">{formatPayout(guaranteedPricePool / 100)}</P>
            </Div>
          )}
        </Div>
      )}

      <Div row mt={15}>
        <P flex={isFullSwing ? 0.6 : 1} fw="500" ta="center">Place</P>
        <P flex={1} fw="500" ta="center">
          {state === TournamentState.FINISHED ? 'Payout' : 'Payout (Projected)'}
        </P>
      </Div>

      {isFullSwing && <Div h={1} bg="#484848" m={5}/>}

      <Div flex={1} position="relative">
        <ScrollView>
          {!!prizeDistribution ? prizeDistribution.map(el => (
            <Div key={el.place} row position="relative" alignItems="center">
              <P ta="center" fw="500" fs={20} flex={isFullSwing ? 0.6 : 1} lh={24}>{el.place}</P>

              <Div mx="auto" w={1} h={24} bg={colors.settings_border}/>

              <Div flex={1} row alignItems="center" mx={25}>
                <P color={isFullSwing ? '#0AF' : colors.newGreenText} fw="500" fs={20} flex={1} lh={24}>
                  {renderPayout(el)}
                </P>

                <Div row w={40}>
                  {(!!el.additionalCashPrize || !!el.staticAwardPrize || !!el.calculatedAwardPrize) && (
                    <Image source={circle as any} style={{width: 14, height: 14, marginRight: 5}}/>
                  )}

                  {el.kind === AwardKind.TICKET && (
                    <Image source={ticket as any} style={{width: 14, height: 14, marginRight: 5}}/>
                  )}

                  {el.kind === AwardKind.PHYSICAL_PRIZE && (
                    <Image source={fs_kit as any} style={{width: 14, height: 14}}/>
                  )}
                </Div>
              </Div>
            </Div>
          )) : (prizePoolList && prizePoolList.length) ? prizePoolList.sort(compareNumbers).map((prize, i) => (
            <Div key={i} row>
              <P ta="center" fw="500" fs={20} flex={isFullSwing ? 0.6 : 1} lh={24}>{i + 1}</P>
              <Div mx="auto" w={1} h={24} bg={colors.settings_border}/>
              <P color={isFullSwing ? '#0AF' : colors.newGreenText} ta="center" fw="500" fs={20} flex={1} lh={24}>
                {prize ? formatCurrency(prize / 100) : '$0'}
              </P>
            </Div>
          )) : (playerDetailsList && playerDetailsList.length) ? playerDetailsList.sort(comparePlayerDetails).map((el, i) => (
            <Div key={el.playerId} row>
              <P ta="center" fw="500" fs={20} flex={isFullSwing ? 0.6 : 1} lh={24}>{i + 1}</P>
              <Div mx="auto" w={1} h={24} bg={colors.settings_border}/>
              <P color={isFullSwing ? '#0AF' : colors.newGreenText} ta="center" fw="500" fs={20} flex={1} lh={24}>
                {el.prize ? formatCurrency(el.prize / 100) : '$0'}
              </P>
            </Div>
          )) : null}
        </ScrollView>

        {!!guaranteedPricePool && !isFullSwing && (
          <Div position="absolute" top={0} left={0} w="100%" h="100%" alignItems="center" justifyContent="center">
            <P fw="500" fs={12} tt="uppercase">guaranteed</P>
            <P fw="500" fs={12} tt="uppercase">prize pool</P>
            <P color={isFullSwing ? '#0AF' : colors.newGreenText} fw="500" fs={24}>
              {formatPayout(guaranteedPricePool / 100)}
            </P>
          </Div>
        )}
      </Div>
    </Div>
  );
};

export default React.memo(PrizePool);
